import React from "react";
import styled from "styled-components";
import InputItem from "../atoms/InputItem";
import InputWrapper from "../atoms/InputWrapper";
import InputItemWrapper from "../atoms/InputItemWrapper";
const StyledInputWrapper = styled(InputWrapper) `
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
`;
const StyledWrapperPostalCode = styled(InputItemWrapper) `
    width: 30%;

    @media only screen and (max-width: 500px) {
        width: 50%;
        margin-bottom: 30px;
    }
`;
const StyledWrapperNumber = styled(InputItemWrapper) `
    width: 30%;

    @media only screen and (max-width: 500px) {
        width: 50%;
        margin-bottom: 30px;
        padding: 0;
    }
`;
const StyledWrapperAttachment = styled(InputItemWrapper) `
    width: 40%;

    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;
const StyledWrapperStreet = styled(InputItemWrapper) `
    width: 60%;

    @media only screen and (max-width: 500px) {
        width: 100%;
        margin-bottom: 30px;
        padding: 0;
    }
`;
const StyledWrapperCity = styled(InputItemWrapper) `
    width: 40%;

    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;
const AddressFieldGroup = ({ data, onChangeHandler, fieldNamePrefix = "", errors, loading, requiredFields, }) => (React.createElement(React.Fragment, null,
    React.createElement(StyledInputWrapper, null,
        React.createElement(StyledWrapperPostalCode, null,
            React.createElement(InputItem, { required: requiredFields, error: errors[fieldNamePrefix + "postal_code"], value: data[fieldNamePrefix + "postal_code"], onChange: onChangeHandler, name: fieldNamePrefix + "postal_code", type: "text", label: "Postcode", disabled: loading })),
        React.createElement(StyledWrapperNumber, null,
            React.createElement(InputItem, { required: requiredFields, error: errors[fieldNamePrefix + "house_number"], value: data[fieldNamePrefix + "house_number"] || "", onChange: onChangeHandler, name: fieldNamePrefix + "house_number", type: "text", pattern: "\\d+", label: "Huisnummer", disabled: loading })),
        React.createElement(StyledWrapperAttachment, null,
            React.createElement(InputItem, { error: errors[fieldNamePrefix + "house_number_addition"], value: data[fieldNamePrefix + "house_number_addition"], onChange: onChangeHandler, name: fieldNamePrefix + "house_number_addition", type: "text", label: "Toevoeging", disabled: loading }))),
    React.createElement(StyledInputWrapper, null,
        React.createElement(StyledWrapperStreet, null,
            React.createElement(InputItem, { required: requiredFields, error: errors[fieldNamePrefix + "street"], value: data[fieldNamePrefix + "street"], onChange: onChangeHandler, name: fieldNamePrefix + "street", type: "text", label: "Straatnaam", disabled: loading })),
        React.createElement(StyledWrapperCity, null,
            React.createElement(InputItem, { required: requiredFields, error: errors[fieldNamePrefix + "city"], value: data[fieldNamePrefix + "city"], onChange: onChangeHandler, name: fieldNamePrefix + "city", type: "text", label: "Plaatsnaam", disabled: loading })))));
export default AddressFieldGroup;
